import { asLeftIPTransmitterSectionData } from './Data/P6142.data';

export const selectAsLeftIPTransmitterSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if (['P6-14.2', 'P7-31', 'P6-23.2', 'P6-14'].includes(formName)) {
        filterViewData = asLeftIPTransmitterSectionData(selectedTag, formName, formData);
    }
    return filterViewData;
};
